/* Tysk katalog for locale-invoice-list-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'listControl.dialog': 'Schließe den offenen Dialog, bevor der Chat mit der Rechnungsliste fortfährt.',
  'live.set_document_type': 'Dokumenttyp wird gewählt …',
  'listControl.alreadyDone': 'Die Aktion wurde für dieses Dokument in dieser Anfrage bereits ausgeführt.',
  'listControl.choice.attachment': 'PDF-Anhang',
  'listControl.choice.link': 'Link',
  'listControl.choice.reminder': 'Zahlungserinnerung',
  'listControl.choice.purring': 'Mahnung',
  'listControl.working': 'Rechnungsliste wird bearbeitet …',
  'listControl.unavailable': 'Die Rechnungsliste ist nicht bereit. Öffne die Seite und versuche es erneut.',
  'listControl.selection': 'Wähle eindeutige Dokumente aus dem Suchergebnis, höchstens 20 auf einmal.',
  'listControl.changed': 'Die Liste oder Auswahl hat sich geändert. Suche und wähle die Dokumente erneut.',
  'listControl.invalid': 'Der Aktion fehlen gültige Details.',
  'listControl.ineligible': 'Diese Aktion passt nicht für alle ausgewählten Dokumente.',
  'listControl.reason': 'Gib den Grund für die Gutschrift an.',
  'listControl.reminder': 'Wähle eine unbezahlte Rechnung, die Art der Erinnerung und ein neues Fälligkeitsdatum. Der Versand erfolgt ohne Gebühr.',
  'listControl.payment': 'Gib für eine Rechnung einen Betrag innerhalb des offenen Saldos, ein Zahlungsdatum und ein Zahlungskonto an.',
  'listControl.conversion': 'Wähle ein fertiges Angebot ohne frühere Umwandlungen. Nutze Erstellen auf der Seite, wenn du eine zusätzliche Umwandlung brauchst.',
  'listControl.uncertain': 'Das Ergebnis ist nicht bestätigt. Prüfe das Dokument vor einem neuen Versuch; der Chat versucht es nicht automatisch erneut.',
  'listControl.unsaved': 'Speichere oder schließe den offenen Entwurf, bevor du das Dokument wechselst.',
  'listControl.stopped': 'Der Rest der Auswahl wurde nicht ausgeführt.',
  'listControl.done.searched': 'Die Suche wird in der Rechnungsliste angezeigt.',
  'listControl.done.selected': 'Die Dokumente sind in der Liste ausgewählt.',
  'listControl.done.opened': 'Das Dokument ist geöffnet.',
  'listControl.done.unsaved': 'Der Entwurf ist geöffnet und noch nicht gespeichert.',
  'listControl.done.prepared': 'Die Aktion und die Details werden unten angezeigt.',
  'listControl.done.sent': 'Gesendet.',
  'listControl.done.paid': 'Die Zahlung ist erfasst.',
  'listControl.done.deleted': 'Der Entwurf ist gelöscht.',
  'listControl.done.archived': 'Archiviert.',
  'listControl.done.restored': 'Aus dem Archiv wiederhergestellt.',
  'listControl.done.creditDraft': 'Die Gutschrift ist als Entwurf gespeichert.',
  'listControl.done.issued': 'Das Dokument ist erstellt.',
  'listControl.operation.send': 'Dokumente senden',
  'listControl.operation.reminder': 'Erinnerung / Mahnung ohne Gebühr senden',
  'listControl.operation.credit': 'Gutschrift erstellen',
  'listControl.operation.archive': 'Archivieren',
  'listControl.operation.restore': 'Aus dem Archiv holen',
  'listControl.operation.delete_draft': 'Entwurf löschen',
  'listControl.operation.register_payment': 'Zahlung erfassen',
  'listControl.operation.issue_draft': 'Dokument erstellen',
  'listControl.option.recipientEmail': 'Empfänger',
  'listControl.option.deliveryMode': 'Versandart',
  'listControl.option.variant': 'Typ',
  'listControl.option.dueDate': 'Fälligkeitsdatum',
  'listControl.option.comment': 'Kommentar',
  'listControl.option.creditReason': 'Grund',
  'listControl.option.issue': 'Fertige Gutschrift erstellen',
  'listControl.option.amount': 'Betrag',
  'listControl.option.date': 'Zahlungsdatum',
  'listControl.option.settlementAccountCode': 'Zahlungskonto',
  'listControl.option.note': 'Notiz',
  'live.done.set_document_type': 'Der Dokumenttyp ist gewählt.',
});
